import {
    /** auth */
    FETCH_AUTH_RESOURCE_REQUEST,
    FETCH_AUTH_RESOURCE_SUCCESS,
    FETCH_AUTH_RESOURCE_FAILED,
    CREATE_MEMBER_AUTH_REQUEST,
    CREATE_MEMBER_AUTH_SUCCESS,
    CREATE_MEMBER_AUTH_FAILED,
    CREATE_MEMBER_AUTH_OTP_REQUEST,
    CREATE_MEMBER_AUTH_OTP_SUCCESS,
    CREATE_MEMBER_AUTH_OTP_FAILED,
    DELETE_MEMBER_AUTH_REQUEST,
    DELETE_MEMBER_AUTH_SUCCESS,
    DELETE_MEMBER_AUTH_FAILED,
    SAVE_REQUIRED_SERVICE,
    /** profile */
    RESET_PASSWORD_REQUEST,
    RESET_PASSWORD_SUCCESS,
    RESET_PASSWORD_FAILED,
    CREATE_PRIVACY_DOCUMENT_REQUEST,
    CREATE_PRIVACY_DOCUMENT_SUCCESS,
    CREATE_PRIVACY_DOCUMENT_FAILED,
    /** only mutation */
    UPDATE_GROUP_OPTIONS,
    /** common */
    FETCH_SELECTED_PROJECT,
    FETCH_SELECTED_MONTH,
    FETCH_SELECTED_MONTH_RANGE,
    FETCH_SELECTED_GROUP,
    FETCH_MONTHS_REQUEST,
    FETCH_MONTHS_SUCCESS,
    FETCH_MONTHS_FAILED,
    CHANGE_PROJECT,
    /** Board */
    FETCH_BOARD_DOCUMENTS_REQUEST,
    FETCH_BOARD_DOCUMENTS_SUCCESS,
    FETCH_BOARD_DOCUMENTS_FAILED,
    FETCH_BOARD_DOCUMENT_REQUEST,
    FETCH_BOARD_DOCUMENT_SUCCESS,
    FETCH_BOARD_DOCUMENT_FAILED,
    /** Megazone Pops */
    CREATE_MEGAZONE_POPS_AUTH_REQUEST,
    CREATE_MEGAZONE_POPS_AUTH_SUCCESS,
    CREATE_MEGAZONE_POPS_AUTH_FAILED,
    /** agreement when first `Megazone Pops` login */
    FETCH_PRIVACY_DOCUMENT_REQUEST,
    FETCH_PRIVACY_DOCUMENT_SUCCESS,
    FETCH_PRIVACY_DOCUMENT_FAILED,
    FETCH_PRIVACY_DOCUMENT_VERSIONS_REQUEST,
    FETCH_PRIVACY_DOCUMENT_VERSIONS_SUCCESS,
    FETCH_PRIVACY_DOCUMENT_VERSIONS,
    /** region */
    FETCH_REGION_REQUEST,
    FETCH_REGION_SUCCESS,
    FETCH_REGION_FAILED,
    /** Tags */
    FETCH_TAGS_REQUEST,
    FETCH_TAGS_SUCCESS,
    FETCH_TAGS_FAILED
} from './mutation-type'
import bus from '@/libs/bus'

const mutations = {
    /** Megazone Pops */
    [CREATE_MEGAZONE_POPS_AUTH_REQUEST]: state => {
        state.status = 'loading'
    },
    [CREATE_MEGAZONE_POPS_AUTH_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [CREATE_MEGAZONE_POPS_AUTH_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
    },
    /*
        auth
    */
    [FETCH_AUTH_RESOURCE_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_AUTH_RESOURCE_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [FETCH_AUTH_RESOURCE_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
        localStorage.removeItem('x-auth-token')
    },
    [CREATE_MEMBER_AUTH_REQUEST]: state => {
        state.status = 'loading'
    },
    [CREATE_MEMBER_AUTH_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [CREATE_MEMBER_AUTH_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
        localStorage.removeItem('x-auth-token')
    },
    [CREATE_MEMBER_AUTH_OTP_REQUEST]: state => {
        state.status = 'loading'
    },
    [CREATE_MEMBER_AUTH_OTP_SUCCESS]: (state, data) => {
        storeUserAuthInfo(state, data)
        state.status = 'success'
        state.auth.message = undefined
    },
    [CREATE_MEMBER_AUTH_OTP_FAILED]: (state, error) => {
        state.status = 'error'
        state.auth.message = error.response && error.response.data && error.response.data.message
    },
    [DELETE_MEMBER_AUTH_REQUEST]: state => {
        state.status = 'loading'
    },
    [DELETE_MEMBER_AUTH_SUCCESS]: (state, data) => {
        localStorage.removeItem('x-auth-token')
        localStorage.removeItem('NAMESPACE')
        state.status = 'success'
    },
    [DELETE_MEMBER_AUTH_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [SAVE_REQUIRED_SERVICE]: (state, data) => {
        state.auth.requiredService = data
    },
    [RESET_PASSWORD_REQUEST]: state => {
        state.status = 'loading'
    },
    [RESET_PASSWORD_SUCCESS]: (state, data) => {
        state.status = 'success'
        bus.$emit('request:success', { title: 'SUCCESS', content: data.status })
    },
    [RESET_PASSWORD_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [CREATE_PRIVACY_DOCUMENT_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [CREATE_PRIVACY_DOCUMENT_SUCCESS]: (state, data) => {
        state.status = 'success'
    },
    [CREATE_PRIVACY_DOCUMENT_FAILED]: (state, data) => {
        state.status = 'error'
    },
    /*
        only mutation
    */
    [UPDATE_GROUP_OPTIONS]: (state, value) => {
        state.hasGroupOptions = value
    },
    /*
        common
    */
    [FETCH_SELECTED_PROJECT]: (state, data) => {
        state.selectedProject = data
    },
    [FETCH_SELECTED_MONTH]: (state, data) => {
        state.selectedMonth = data
    },
    [FETCH_SELECTED_MONTH_RANGE]: (state, data) => {
        state.selectedMonthRange = data
    },
    [FETCH_SELECTED_GROUP]: (state, data) => {
        state.selectedGroup = data
    },
    [FETCH_MONTHS_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_MONTHS_SUCCESS]: (state, { data }) => {
        if (data.monthList && data.monthList.length) {
            state.months = data.monthList
            state.selectedMonth = data.monthList[0]
        } else {
            state.months = []
        }
        state.status = 'success'
    },
    [FETCH_MONTHS_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [CHANGE_PROJECT]: (state, data) => {
        state.changeProject = {
            event: data.event,
            value: data.value
        }
    },
    /*
        board
    */
    [FETCH_BOARD_DOCUMENTS_REQUEST]: state => {
        state.boardDocumentsStatus = 'loading'
    },
    [FETCH_BOARD_DOCUMENTS_SUCCESS]: (state, data) => {
        state.boardDocumentsStatus = 'success'
        state.boardDocuments = data.data.documents
    },
    [FETCH_BOARD_DOCUMENTS_FAILED]: (state, error) => {
        state.boardDocumentsStatus = 'error'
    },
    [FETCH_BOARD_DOCUMENT_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_BOARD_DOCUMENT_SUCCESS]: (state, data) => {
        state.boardDocument = data.data.document
        state.status = 'success'
    },
    [FETCH_BOARD_DOCUMENT_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_PRIVACY_DOCUMENT_REQUEST]: (state, data) => {
        state.status = 'loading'
    },
    [FETCH_PRIVACY_DOCUMENT_SUCCESS]: (state, data) => {
        state.status = 'success'
        state.privacy.document = data
    },
    [FETCH_PRIVACY_DOCUMENT_FAILED]: (state, error) => {
        state.status = 'error'
    },
    [FETCH_PRIVACY_DOCUMENT_VERSIONS_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_PRIVACY_DOCUMENT_VERSIONS_SUCCESS]: (state, { data }) => {
        state.status = 'success'
        // const xmlParser = require('xml2js')
        state.privacy.versions = data.map(jsonFile => jsonFile.replace('.json', '')).sort((a, b) => a > b ? -1 : 1)
        // xmlParser.parseString(data, (err, result) => {
        //     if (err) throw err
        //     state.privacy.versions = result.ListBucketResult.Contents.filter(content => {
        //         return content.Key[0].indexOf('.json') > -1
        //     }).map(content => {
        //         return content.Key[0].split('/')[content.Key[0].split('/').length - 1].replace('.json', '')
        //     }).sort((a, b) => a > b ? -1 : 1)
        // })
    },
    [FETCH_PRIVACY_DOCUMENT_VERSIONS]: (state, error) => {
        state.status = 'error'
    },
    /**
     * region
     */
    [FETCH_REGION_REQUEST]: state => {
        state.status = 'loading'
    },
    [FETCH_REGION_SUCCESS]: (state, data) => {
        state.status = 'success'
        state.regions = data
    },
    [FETCH_REGION_FAILED]: (state, error) => {
        state.status = 'error'
    },
    /**
     *  Tags
     */
    [FETCH_TAGS_REQUEST]: state => {
        state.stauts = 'loading'
    },
    [FETCH_TAGS_SUCCESS]: (state, { data }) => {
        state.stauts = 'success'
        state.tags = data
    },
    [FETCH_TAGS_FAILED]: (state, error) => {
        state.stauts = 'error'
    }
}
const storeUserAuthInfo = (state, data) => {
    localStorage.setItem('x-auth-token', data.token)
    state.auth.prerequisites = data.prerequisites || []
    state.auth.needPrerequisite = data.needPrerequisite
    state.auth.userInfo = data.userInfo
    state.auth.serviceGroups = data.serviceGroups || []
    state.auth.resource.projects = []
    if (data.userResource) {
        state.auth.resource.projectIdxs = data.userResource.projectIdxs || []
        state.auth.resource.userRights = data.userResource.userRights || []
        state.auth.resource.myOwnProjects = data.userResource.myOwnProjects || []
        state.auth.resource.additionalProjects = data.userResource.additionalProjects || []

        if (data.userResource.groups) {
            state.auth.resource.groups = data.userResource.groups.sort((a, b) => {
                if (a.groupNamePath < b.groupNamePath) {
                    return -1
                }
                if (a.groupNamePath > b.groupNamePath) {
                    return 1
                }
            })
            const groupOptionMap = {}
            data.userResource.groups.forEach((group) => {
                groupOptionMap[group.groupIdx] = data.userResource.groups.filter(innerGroup => {
                    return group.groupNamePath.split('>').every((value, index) => value.trim() === innerGroup.groupNamePath.split('>')[index]?.trim())
                })
                state.auth.resource.groupProjectMap[group.groupIdx] = groupOptionMap[group.groupIdx].reduce((accumulator, currentValue) => accumulator.concat(currentValue.projects), [])
                group.projects.forEach(project => {
                    state.auth.resource.accountMap[project.usageAccountId] = project.projectName
                    state.auth.resource.projects.push(project)
                })
            })
        }
    }

    // Redirect if need prerequisite
    const isCommonLogin = process.env.VUE_APP_COMMON_LOGIN === 'TRUE'
    if (data.needPrerequisite) {
        const token = localStorage.getItem('x-auth-token')
        if (isCommonLogin && data?.prerequisites.some(value => value === 'password' || value === 'otp')) {
            localStorage.removeItem('x-auth-token')
            const site = process.env.VUE_APP_SERVICE
            window.location.href = `${process.env.VUE_APP_AUTH_CENTER_URL}/signin/email/${data.userInfo.email}/token/${token}/from/${site}`
        }
    }
}

export default mutations
